import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl, baseimgUrl } from "../Univ";
import { Link, useNavigate } from "react-router-dom";

function Home() {

  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  const isLoggedIn = localStorage.getItem("userGroup") === "Customer";

  useEffect(() => {
    fetchProducts();
  }, []);

  // -----------------------
  // FETCH PRODUCTS (PUBLIC)
  // -----------------------
  const fetchProducts = async () => {
    try {
      const res = await axios.get(baseUrl + "view-products/");
      setProducts(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  // -----------------------
  // ADD TO CART
  // -----------------------
  const addToCart = async (id) => {

    if (!isLoggedIn) {
      navigate("/user-login/");
      return;
    }

    await axios.post(
      baseUrl + "add-cart/",
      { product_id: id },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      }
    );

    alert("Added to cart");
  };

  // -----------------------
  // ADD TO WISHLIST
  // -----------------------
  const addWishlist = async (id) => {

    if (!isLoggedIn) {
      navigate("/user-login/");
      return;
    }

    await axios.post(
      baseUrl + "add-wishlist/",
      { product_id: id },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      }
    );

    alert("Added to wishlist");
  };

  // -----------------------
  // UI
  // -----------------------
  return (

    <div className="container mt-4">

      <h3 className="mb-4">Latest Products</h3>

      <div className="row">

        {products.map((p) => (

          <div key={p.id} className="col-md-3 mb-4">

            <div className="card h-100 shadow-sm">

              {/* IMAGE */}
              <Link to={`/product/${p.id}`}>
                <img
                  src={`${p.images?.[0]?.image || "https://via.placeholder.com/180x150?text=No+Image"}`}
                  alt={p.name}
                  className="card-img-top"
                  style={{ height: "180px", objectFit: "cover" }}
                />
              </Link>

              <div className="card-body">

                <h6>{p.name}</h6>

                <div className="mb-2">
                  <h5 className="text-success d-inline me-2">
                    ₹{p.discount_price || p.price}
                  </h5>

                  {p.discount_price && (
                    <span className="text-muted text-decoration-line-through">
                      ₹{p.price}
                    </span>
                  )}
                </div>

                {/* ACTION BUTTONS */}
                <div className="d-flex gap-2">

                  <button
                      className="icon-btn cart-btn"
                      onClick={() => addToCart(p.id)}
                    >
                      <i className="fa-solid fa-cart-shopping"></i>
                    </button>

                    <button
                      className="icon-btn wish-btn"
                      onClick={() => addWishlist(p.id)}
                    >
                      <i className="fa-regular fa-heart"></i>
                    </button>



                </div>

              </div>

            </div>

          </div>

        ))}

      </div>

    </div>

  );
}

export default Home;
